var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import selectn from "selectn";

import Headline from "../Headline";
import styles from "./EventCard.css";

var EventCard = function (_Component) {
  _inherits(EventCard, _Component);

  function EventCard() {
    _classCallCheck(this, EventCard);

    return _possibleConstructorReturn(this, (EventCard.__proto__ || Object.getPrototypeOf(EventCard)).apply(this, arguments));
  }

  _createClass(EventCard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          isLastStory = _props.isLastStory;

      if (!story) return null;
      var image = selectn("primary_image.crops.1x1.url", story);

      return React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          { key: story.id, className: styles.root },
          image && React.createElement("img", { className: styles.image, src: image, alt: story.primary_image.alt_text }),
          React.createElement(
            "div",
            null,
            React.createElement(Headline, { headline: story.headline }),
            React.createElement(
              "div",
              { className: styles.description },
              story.og_description
            )
          )
        ),
        !isLastStory && React.createElement("hr", { className: styles.separator, "aria-hidden": true })
      );
    }
  }]);

  return EventCard;
}(Component);

export default EventCard;


// WEBPACK FOOTER //
// ./src/components/Library/EventCard/EventCard.js